import _ from 'lodash';

/**
 * Utility method for binding methods in component constructors
 * @param  {Object} context context to bind to
 * @param  {Array} methods  methods The array of method names
 * @return {Undefined} Returns nothing
 */
export function bindMethods(context, methods) {
  _.forEach(methods, method => {
    if (_.isFunction(context[method])) {
      context[method] = context[method].bind(context);
    }
  });
}

/**
 * Handler for the keydown event to add accessibility to non accessible html elements
 * @param  {Object}   e Event
 * @param  {Function} callback Function to call after keydown
 * @return {Undefined} Returns nothing
 */
export function handleAccessibleKeyDown(e, callback) {
  const code = e.keyCode ? e.keyCode : e.which;
  const ENTER = 13;
  const SPACEBAR = 32;

  if (code === ENTER || code === SPACEBAR) {
    e.preventDefault();
    e.stopPropagation();
    return callback();
  }
}

/**
 * Detects if using an inferior browser or not
 * @param {Object} navigator The browser navigator object
 * @return {Boolean} If the current browser is inferior
 */
export function isInferiorBrowser(navigator) {
  return (
    !_.isObject(navigator) ||
    (navigator.userAgent.indexOf('MSIE ') > -1 ||
      (navigator.appName === 'Microsoft Internet Explorer' ||
        (navigator.appName === 'Netscape' &&
          new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(
            navigator.userAgent
          ) !== null)) ||
      navigator.userAgent.indexOf('Firefox') > -1)
  );
}

/**
 * Generic set ref method
 * @param {Element|Object} ref The ref to element/instance
 * @param {String} key The key to be stored on the instance
 * @param {Object} context The context to be set to
 * @returns {Undefined} Returns nothing
 */
export function setRef(ref, key, context) {
  if (ref && _.isString(key)) {
    context[key] = ref;
  }
}

/**
 * Determines the file type
 * @method getMediaType
 * @param  {string} mimetype epxected format: <type>/<extension>
 * @return {string} returns the file type for display
 */
export function getMediaType(mimetype) {
  const type = _.isString(mimetype)
    ? mimetype.substr(0, mimetype.indexOf('/'))
    : 'default';

  const types = {
    video: 'Video',
    image: 'Photo',
    audio: 'Audio',
    default: 'Item',
  };

  return types[type] || types.default;
}

/**
 * Determine the file extension via the mimetype
 * @method getMediaExtension
 * @param  {string} mimetype epxected format: <type>/<extension>
 * @return {string} returns the file extension
 */
export function getMediaExtension(mimetype) {
  return _.isString(mimetype) ? _.last(mimetype.split('/')) : '';
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/componentHelpers.js